import { Avatar, AvatarProps, styled } from "@mui/material";
import React from "react";
import { pxToRem } from "../../utils/fontSizeUtility";

export const AvatarNav = styled(Avatar)<AvatarProps>(({ theme }) => ({
  width: pxToRem(35),
  height: pxToRem(35),
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  marginRight: pxToRem(15),
  marginLeft: pxToRem(10),
})) as React.ComponentType<AvatarProps>;
